import React from "react";
import { PaginationIcon } from "~/assets/svg/InterfaceIcon";
import darkLogoImg from "~/assets/img/defaultImg/dark-logo-square.png";
import lightLogoImg from "~/assets/img/defaultImg/light-logo-square.png";
// Components
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import EvaluateSection from "./EvaluateSection";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";
import { dateToString } from "~/utils/formatter";

const EvaluatePopup = ({
	applyResultModal,
	setApplyResultModal,
	setCompanyDetailModal,
	showConfirmAlert,
	evalDetailData,
	evalListData,
	viewtype,
	getEvalData,
	pageInfo,
	viewEvalPopup,
	handlePage,
}) => {
	const { t } = useTranslation();
	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();
	const evalIdxList = evalListData?.list?.map((company) => company.idx);
	const evalIdxAllList = evalListData?.roundApplyCompanyIdxList;

	const currentIdx = evalDetailData?.info?.idx;
	const currentListIdx = evalIdxList?.indexOf(currentIdx);
	const currentAllListIdx = evalIdxAllList?.indexOf(currentIdx);

	const logoImg = theme === "dark" ? darkLogoImg : lightLogoImg;
	const isFirst = () => {
		return pageInfo?.cPage === 1 && currentListIdx === 0;
	};

	const isEnd = () => {
		return (
			pageInfo?.cPage === pageInfo?.totalPages && currentListIdx === evalIdxList?.length - 1
		);
	};

	const getPrev = () => {
		if (currentListIdx === 0) {
			handlePage(pageInfo?.cPage - 1);
		}
		viewEvalPopup(evalIdxAllList[currentAllListIdx - 1]);
	};

	const getNext = () => {
		if (currentListIdx === evalIdxList?.length - 1) {
			handlePage(pageInfo?.cPage + 1);
		}
		viewEvalPopup(evalIdxAllList[currentAllListIdx + 1]);
	};

	return (
		<ModalTemplate
			modalState={applyResultModal}
			setModalToggle={setApplyResultModal}
			title={
				<>
					<div className="applicant-detail-header">
						{/*<div>*/}
						<span className="title">
							{t("pages.round.RoundList.component.EvaluatePopup.title")}{" "}
						</span>
						<span>{evalListData?.round?.title}</span>
						{/*</div>*/}
						{/*<button*/}
						{/*	className="modal-close divided-close"*/}
						{/*	onClick={() => setApplyResultModal(false)}*/}
						{/*>*/}
						{/*	<SolidCloseIcon />*/}
						{/*</button>*/}
					</div>
					{/*{viewtype && <div className="applicant-evaluate-header">심사평가</div>}*/}
				</>
			}
			width={1470}
			height={930}
			className="apply-result-modal evaluate-result-wrap"
		>
			{!isFirst() && (
				<div className="arrow-btn prev-btn" onClick={() => getPrev()}>
					<PaginationIcon />
				</div>
			)}
			<div className="modal-content">
				<div className="applicant-detail-body">
					<div className="applicant-info">
						<div className="company-info-wrap">
							<div className="img-wrap">
								<img
									src={
										evalDetailData?.company?.logoSqu
											? evalDetailData?.company?.logoSqu
											: logoImg
									}
									alt={t("pages.round.RoundList.component.EvaluatePopup.logo")}
								/>
							</div>
							<div className="company-info">
								<div
									className={`company-status ${
										evalDetailData?.reviewResult ? "done" : ""
									}`}
								>
									{evalDetailData?.reviewResult
										? evalDetailData?.reviewResult?.status
										: "심사대기"}
								</div>
								<h4 className="company-name">{evalDetailData?.company?.name}</h4>
								<span className="company-abst">
									{evalDetailData?.company?.address
										? evalDetailData?.company?.address.substring(0, 2)
										: "-"}{" "}
									/{" "}
									{new Date().getFullYear() -
										parseInt(evalDetailData?.company?.estDate?.substring(0, 4))}
									{t("pages.round.RoundList.component.EvaluatePopup.year")}{" "}
									{new Date().getMonth() -
										parseInt(evalDetailData?.company?.estDate?.substring(5, 7))}
									{t("pages.round.RoundList.component.EvaluatePopup.month")} /{" "}
									{evalDetailData?.company?.bizType}
								</span>
							</div>
						</div>
						<button
							className="btn__outline angled"
							color="primary"
							onClick={() => setCompanyDetailModal(true)}
						>
							{t("pages.round.RoundList.component.EvaluatePopup.companyInfo")}
						</button>
					</div>
					{evalDetailData.answer && evalDetailData.answer.length > 0 && (
						<section>
							<h3 className="section-title">
								{t("pages.round.RoundList.component.EvaluatePopup.termsOfUse")}
							</h3>
							<div className="c__form">
								<div className="f__group">
									<div className="f__label">
										{t(
											"pages.round.RoundList.component.EvaluatePopup.privacyPolicy"
										)}
									</div>
									<div className="f__control">
										{t("pages.round.RoundList.component.EvaluatePopup.agree")}
									</div>
								</div>
							</div>
						</section>
					)}
					<section>
						<div className="c__form">
							{evalDetailData.answer &&
								evalDetailData.answer.length > 0 &&
								evalDetailData.answer.map((inquiry) => {
									switch (inquiry.type) {
										case "CATEGORY":
											return <h4 className="category-title">{ (inquiry.title !== "none") ? inquiry.title : "" }</h4>;
										case "AGREE":
											return (
												<div
													className={`f__group ${
														inquiry.required ? "required" : ""
													}`}
												>
													<div className="f__label">{inquiry.title}</div>
													<div className="f__control">
														{inquiry.answer
															? t(
																	"pages.round.RoundList.component.EvaluatePopup.agree"
															  )
															: t(
																	"pages.round.RoundList.component.EvaluatePopup.disagree"
															  )}
													</div>
												</div>
											);
										case "TEXT":
											return (
												<div
													className={`f__group ${
														inquiry.required ? "required" : ""
													}`}
												>
													<div className="f__label">
														* {inquiry.title}
													</div>
												</div>
											);
										case "TAG":
											return (
												<div
													className={`f__group ${
														inquiry.required ? "required" : ""
													}`}
												>
													<div className="f__label">{inquiry.title}</div>
													<div className="f__control">
														{inquiry.answer &&
														inquiry.answer?.length > 0
															? inquiry.answer.join(", ")
															: "-"}
													</div>
												</div>
											);
										case "FILE":
											const answer = { name: "", url: "" };
											if (
												inquiry?.answer &&
												inquiry?.answer.search("name") > 0
											) {
												let answerObject = JSON.parse(inquiry.answer);
												answer.name = answerObject.name;
												answer.url = answerObject.url;
											} else {
												answer.name = "-";
												answer.url = inquiry.url;
											}

											return (
												<div
													className={`f__group ${
														inquiry.required ? "required" : ""
													}`}
												>
													<div className="f__label">
														{inquiry.title}(첨부파일)
													</div>
													<div className="f__control">
														<a href={answer.url}>{answer?.name}</a>
													</div>
												</div>
											);
										case "TITLE":
											return null;
										case "LINK":
											return (
												<div
													className={`f__group ${
														inquiry.required ? "required" : ""
													}`}
												>
													<div className="f__label">
														{inquiry.title}(
														{t(
															"pages.round.RoundList.component.EvaluatePopup.link"
														)}
														)
													</div>
													<div className="f__control">
														<a
															href={
																inquiry?.answer?.startsWith("http")
																	? inquiry?.answer
																	: `http://${inquiry?.answer}`
															}
															target="_blank"
														>
															{inquiry.answer}
														</a>
													</div>
												</div>
											);
										case "DATE":
											return (
												<div
													className={`f__group ${
														inquiry.required ? "required" : ""
													}`}
												>
													<div className="f__label">{inquiry.title}</div>
													<div className="f__control">
														{inquiry.answer
															? dateToString(
																	inquiry.answer,
																	"yyyy-MM-dd"
															  )
															: "-"}
														{}
													</div>
												</div>
											);
										case "MULTISELECT":
											return (
												<div
													className={`f__group ${
														inquiry.required ? "required" : ""
													}`}
												>
													<div className="f__label">{inquiry.title}</div>
													<div className="f__control">
														{/*
															@INFO
															: 산업분야인경우 item return, 다른 멀티셀렉터는 item.label return
														*/}
														{inquiry.answer &&
															inquiry.answer
																.map((item) => item?.label ?? item)
																.join(",")}
													</div>
												</div>
											);
										default:
											return (
												<div
													className={`f__group ${
														inquiry.required ? "required" : ""
													}`}
												>
													<div className="f__label">{inquiry.title}</div>
													<div className="f__control">
														{inquiry.answer}
													</div>
												</div>
											);
									}
								})}
						</div>
					</section>
				</div>
				<EvaluateSection
					showConfirmAlert={showConfirmAlert}
					evalDetailData={evalDetailData}
					setApplyResultModal={setApplyResultModal}
					viewtype={viewtype}
					getEvalData={getEvalData}
				/>
			</div>
			{!isEnd() && (
				<div className="arrow-btn next-btn" onClick={() => getNext()}>
					<PaginationIcon />
				</div>
			)}
		</ModalTemplate>
	);
};

export default EvaluatePopup;
